import { Box, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface LoadingSpinnerProps {
  label?: string;
}

function LoadingSpinner({ label }: LoadingSpinnerProps) {
  const { t } = useTranslation('admin/map');
  const resolvedLabel = label ?? t('trackingList.loading');

  return (
    <Box className='pointer-events-none absolute top-4 left-4 z-20'>
      <Box className='inline-flex items-center gap-2 rounded-md border border-gray-200 bg-white/90 px-2.5 py-1.5 text-xs text-gray-600 shadow-sm backdrop-blur-[1px]'>
        <CircularProgress size={14} thickness={5} />
        <span>{resolvedLabel}</span>
      </Box>
    </Box>
  );
}

export default LoadingSpinner;
